export const USER_LOGIN = "[USER] USER_LOGIN";
export const USER_LOGIN_SUCCESS = "[USER] USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "[USER] USER_LOGIN_FAILED";